import bg from '../assets/bg.png';
import logo from '../assets/logo.png';
import overlaybg from '../assets/overlaybg.png';
import welcome from '../assets/welcome.png';
import findus from '../assets/findus.png';
import sign from '../assets/sign.png';
import quote from '../assets/quote.png';
import mtn_welcome from '../assets/mtn_welcome.png';
import trav from'../assets/trav.png';
import skiis from '../assets/skiis.svg';
import ski_ex from '../assets/ski_ex.svg'
import csa_logo from '../assets/csa_logo.png'
import founders from '../assets/csa_founding.jpg'
import exec_daylen from '../assets/exec_daylen.png'
import exec_dave from '../assets/exec_dave.png'
import exec_lp from '../assets/exec_lp.png'
import exec_trav from '../assets/exec_trav.png'
import exec_genna from '../assets/exec_genna.png'
import stauff_chile from '../assets/stauff_chile.png'


export default {
  bg,
  logo,
  overlaybg,
  welcome,
  findus,
  sign,
  quote,
  mtn_welcome,
  trav,
  skiis,
  ski_ex,
  csa_logo,
  founders,
  exec_daylen,
  exec_dave,
  exec_lp,
  exec_trav,
  exec_genna,
  stauff_chile
};
